import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './InvoiceList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaEdit, FaEllipsisH, FaFilePdf, FaInfo, FaPlus, FaSearch, FaTrash, FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { DELIVERY_NOTE_PAGE } from '../../routes/routeConstants';
import PaymentBloc from './PaymentBloc';
import { format, parse } from 'date-fns';
import { invoiceSupplierActions } from '../../sagas/invoiceSupplierSlice';
import InvoiceForm from './InvoiceForm';
import { formatPrice } from '../../helpers/utility';
import { supplierActions } from '../../sagas/supplierSlice';
import { components } from 'react-select';
import Select from 'react-select/async';

const SupplierInvoiceSummary = () => {
    const dispatch = useDispatch();
    const { invoicesSummary,
        totalAmountHt,
        totalAmountTtc,
        totalPages,
        totalElements,
        dateFrom,
        dateTo,
        pageSize, loading } = useSelector((state) => state.invoiceSupplier);
    const [filter, setFilter] = useState('');
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [criteria, setSearchCriteria] = useState({ query: '' });
    const [isSearching, setIsSearching] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [isReleveButtonDisabled, setIsReleveButtonDisabled] = useState(true);

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        return format(parse(dateString, "dd/MM/yyyy", new Date()), "yyyy-MM-dd");
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Convert input date format (yyyy-MM-dd) to backend date format (dd/MM/yyyy)
    const formatDateForBackend = (dateString) => {
        if (!dateString) return '';
        const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
        return format(parsedDate, 'dd/MM/yyyy');
    };


    // Extract devisNb from query parameters
    const queryParams = new URLSearchParams(location.search);
    const devisNb = queryParams.get('devisNb');

    useEffect(() => {
        let payload = {
            criteria: criteria,
            page: currentPage,
            size: pageSize,
        };
        dispatch(invoiceSupplierActions.searchInvoiceSummary(payload));
    }, [currentPage, devisNb, criteria, dispatch]);


    const handleDateFilter = () => {
        dispatch(invoiceSupplierActions.searchInvoiceSummary({
            criteria: {
                ...criteria,
                dateFrom: formatDateForBackend(startDate),
                dateTo: formatDateForBackend(endDate),
            },
            page: 1,
            size: pageSize,
        }));
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(invoiceSupplierActions.searchInvoiceSummary({
                criteria: { query },
                page: 1,
                size: pageSize,
                onSuccess: () => setIsSearching(false)
            }));
        }, 500), // Wait 500ms after last keystroke
        []
    );
    const handleFilterChange = (e) => {
        const value = e.target.value;
        setFilter(value);
        debouncedSearch(value);
    };
    const refrechInvoice = () => {
        let payload = {
            criteria,
            page: currentPage,
            size: pageSize,
        };
        dispatch(invoiceSupplierActions.filterInvoice(payload));
    }

    const handleSupplierSelect = (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setIsReleveButtonDisabled(false);
    };

    const handleGenerateReleve = () => {
        if (selectedSupplier) {
            const { supplier } = selectedSupplier;
            dispatch(invoiceSupplierActions.generateReleveRequest({
                supplierId: supplier.id,
                dateFrom: formatDateForBackend(startDate),
                dateTo: formatDateForBackend(endDate),
            }));
        } else {
            Swal.fire({
                icon: 'warning',
                title: t('facture.selectSupplier'),
                showConfirmButton: true,
            });
        }
    };
    

    const handleGeneratePdf = (invoice) => {
        dispatch(invoiceSupplierActions.generatePdfRequest(invoice.id));
        setPopoverOpen(!popoverOpen)
    };

    const loadSupplierOptions = async (inputValue) => {
        return new Promise((resolve) => {
            dispatch(supplierActions.search({
                query: inputValue,
                onSuccess: (data) => {
                    const options = data.content.map(supplier => ({
                        value: supplier.id,
                        label: supplier.businessName,
                        supplier: supplier
                    }));
                    resolve(options);
                }
            }));
        });
    };



    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };



    useEffect(() => {
        if (dateFrom != null) {
            setStartDate(formatDateForInput(dateFrom));
        }

        if (dateTo != null) {
            setEndDate(formatDateForInput(dateTo))
        }

    }, [dateFrom, dateTo])


    if (loading) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <Spinner color="primary" />
            </div>
        );
    }

    const handleExportExcel = () => {
        //dispatch(invoiceSupplierActions.exportExcelRequest({ criteria, page: currentPage, size: pageSize }));
    }

    return (
        <div className="invoice-list-container">
            <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    <h2>{t('summary.suppliersInvoicesState')}</h2>
                    <Button color="primary" onClick={handleExportExcel} className="btn btn-primary">
                        <FaPlus className="mr-2" /> {t('summary.exportBtn')}
                    </Button>
                </CardHeader>
                <CardBody>
                    <div className="filter-container mb-3">
                        <Row>
                            {/* Search Field */}
                            <Col md={3}>
                                <Select
                                    id="supplier"
                                    name="supplier"
                                    isClearable
                                    placeholder={t('purchase.selectSupplier')}
                                    loadOptions={loadSupplierOptions}
                                    onChange={handleSupplierSelect}
                                    defaultOptions
                                    value={selectedSupplier}
                                    className="react-select"
                                    classNamePrefix="select"
                                    noOptionsMessage={() => t('purchase.noSupplierFound')}
                                    loadingMessage={() => t('common.loading')}
                                    components={{
                                        DropdownIndicator: () => <FaUser className="me-2" />,
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>{children}</components.Option>
                                        ),
                                    }}
                                />
                            </Col>

                            {/* Date From Field */}
                            <Col md={3}>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Date de début"
                                />
                            </Col>

                            {/* Date To Field */}
                            <Col md={3}>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Date de fin"
                                />
                            </Col>

                            {/* Filter Button */}
                            <Col md={1}>
                                <Button color="primary" onClick={handleDateFilter} size="sm">
                                    <FaSearch /> {t('facture.filter')}
                                </Button>
                            </Col>
                            <Col md={2}>
                                <Button
                                    color="primary"
                                    onClick={handleGenerateReleve}
                                    disabled={isReleveButtonDisabled}
                                    size="sm"
                                >
                                    {t('summary.generateReleve')}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <table className="table table-hover table-striped">
                        <thead className="thead-light">
                            <tr>
                                <th className="align-middle text-center">{t('purchase.supplier')}</th>
                                <th className="align-middle text-center">{t('summary.totalFactureAmount')}</th>
                                <th className="align-middle text-center">{t('summary.totalAvoirAmount')}</th>
                                <th className="align-middle text-center">{t('summary.totalAmountPaid')}</th>
                                <th className="align-middle text-center">{t('summary.soldeDu')}</th>
                                {/*<th className="align-middle text-center">{t('facture.table.actions')}</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {invoicesSummary?.length === 0 && (
                                <tr>
                                    <td colSpan="8" className="text-center text-muted">
                                        {t('facture.noInvoices')}
                                    </td>
                                </tr>
                            )}
                            {invoicesSummary?.map((summary) => (
                                <tr key={summary.supplierId}>
                                    <td className="align-middle text-center">{summary.supplierName}</td>
                                    <td className="align-middle text-center">{formatPrice(summary.totalFactureAmount)}</td>
                                    <td className="align-middle text-center">{formatPrice(summary.totalAvoirAmount)}</td>
                                    <td className="align-middle text-center">{formatPrice(summary.totalSupplierPayments)}</td>
                                    <td className="align-middle text-center">{formatPrice(summary.totalAmountToBePaid)}</td>
                                    {/*<td className="align-middle text-center">
                                        <span
                                            id={`Popover-${summary.supplierId}`}
                                            title='Afficher les actions'
                                            onClick={() => handleToggleActions(summary)}
                                            className="me-1 px-2 py-1"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <FaEllipsisH size={12} className="mr-2" />
                                        </span>
                                        <Popover
                                            placement="bottom"
                                            isOpen={popoverOpen && selectedInvoice && selectedInvoice.supplierId === summary.supplierId}
                                            target={`Popover-${summary.supplierId}`}
                                            toggle={() => setPopoverOpen(!popoverOpen)}
                                        >
                                            <PopoverBody>
                                                <Button color="secondary" title='Téléchargé PDF' onClick={() => handleGeneratePdf(summary)} size="sm" className="me-1 px-2 py-1">
                                                    <FaFilePdf size={12} className="mr-2" />
                                                </Button>
                                                <Button
                                                    color="primary"
                                                    title="Ajouter un paiement"
                                                    onClick={() => handleShowPaymentModal(summary)}
                                                    size="sm"
                                                    className="me-1 px-2 py-1"
                                                >
                                                    <FaPlus size={12} className="mr-2" />
                                                </Button>
                                                {summary.deliveryNoteNb ? (
                                                    <Button color="info" title='Voir Bon de livraison' onClick={() => navigate(`${DELIVERY_NOTE_PAGE}?blNb=${summary.deliveryNoteNb}`)} size="sm" className="me-1 px-2 py-1">
                                                        <FaInfo size={12} className="mr-2" />
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button color="success" title='Téléchargé Bon de livraison' onClick={() => handleCreateDeliveryNote(summary)} size="sm" className="me-1 px-2 py-1">
                                                            <FaInfo size={12} className="mr-2" />
                                                        </Button>
                                                        <Button color="danger" title='Supprimer' onClick={() => handleDeleteInvoice(summary.supplierId)} size="sm" className="me-1 px-2 py-1">
                                                            <FaTrash size={12} className="mr-2" />
                                                        </Button>
                                                    </>
                                                )}
                                                <Button color="warning" title='Modifier' onClick={() => handleUpdateInvoice(summary)} size="sm" className="px-2 py-1">
                                                    <FaEdit size={12} className="mr-2" />
                                                </Button>
                                            </PopoverBody>
                                        </Popover>

                                    </td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <small className="text-muted">
                            {t('product.showing', {
                                start: (currentPage - 1) * pageSize + 1,
                                end: Math.min(currentPage * pageSize, totalElements),
                                total: totalElements,
                                currentPage: currentPage,
                                totalPages: totalElements
                            })}
                        </small>
                        <Pagination size="sm" className="mb-0">
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink first onClick={() => handlePageChange(1)}>
                                    <FaAngleDoubleLeft size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)}>
                                    <FaAngleLeft size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages}>
                                <PaginationLink next onClick={() => handlePageChange(currentPage + 1)}>
                                    <FaAngleRight size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages}>
                                <PaginationLink last onClick={() => handlePageChange(totalPages)}>
                                    <FaAngleDoubleRight size={12} />
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </div>
                    <div className="mt-4">
                        <Card className="shadow-sm border-0">
                            <CardBody className="d-flex justify-content-between align-items-center">

                                <div className="text-success">
                                    <h5 className="mb-1">{t('summary.soldeDu')}</h5>
                                    <h4 className="fw-bold">{formatPrice(totalAmountTtc)}</h4>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </CardBody>
            </Card>

        </div>
    );
};

export default SupplierInvoiceSummary;